import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import SubscriberDialog from './dialogs/SubscriberDialog';
import SubscriberDeleteDialog from './dialogs/SubscriberDeleteDialog';
import SubscriberRestoreDialog from './dialogs/SubscriberRestoreDialog';
import LicenseErrorDialog from '../common/LicenseErrorDialog';

const SubscribersEditor = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { action1, actionId1 } = useParams();

  const [navigationDepth, setNavigationDepth] = useState(0);
  const [pathname, setPathname] = useState('');

  // navigation effect
  useEffect(() => {
    if (pathname === '') {
      // first call
    } else if (pathname.includes(location.pathname)) {
      setNavigationDepth((depth) => Math.max(0, depth - 1));
    } else {
      setNavigationDepth((depth) => depth + 1);
    }
    setPathname(location.pathname);
  }, [location]);

  const handleClose = () => {
    if (navigationDepth) {
      navigate(-1);
    } else if (actionId1) {
      navigate('../../', { replace: true });
    } else {
      navigate('../', { replace: true });
    }
  };

  return (
    <>
      <LicenseErrorDialog
        handleClose={() => handleClose()}
      />

      <SubscriberDialog
        handleClose={() => handleClose()}
      />

      <SubscriberDeleteDialog
        handleClose={() => handleClose()}
      />

      <SubscriberRestoreDialog
        handleClose={() => handleClose()}
      />
    </>
  );
};

export default SubscribersEditor;
